import Tagging from "components/mnl/lab/courier/tagging";

const TaggingPage = () => {
  return <Tagging />;
};

export default TaggingPage;
